export { default as Switch } from './Switch';
export type { SwitchProps } from './types';
